import { useEffect, useState, useContext } from "react";
import { Button, Icon, UserAvatar } from "components/Component";
import getTextColor from "components/custom/getTextColor";
import { Modal, ModalBody, TabContent, Nav, Dropdown, DropdownToggle, DropdownMenu, DropdownItem } from "reactstrap";
import { serviceGetUsersByRoleId } from "services/users";
import { findUpper, getPermission } from "utils/Utils";
import { useDebounce } from "use-debounce";
import SimpleBar from "simplebar-react";
import { MessagesContext } from "contexts/messagesContext";
import { ChatContext } from "./ChatContext";

const ChatFilterUser = (props) => {
  const {
    cookies,
    isModalFilterUserOpen,
    setIsModalFilterUserOpen,
    userDetail,
    filterChatByUserId,
    isIncludeChatbot,
    BOT_ID,
    setFilterUserName,
  } = props;

  const [activeTab, setActiveTab] = useState(0);
  const [search, setSearch] = useState("");
  const [selectedUserId, setSelectedUserId] = useState("");
  const [searchText] = useDebounce(search, 100);
  const { onlineValue } = useContext(MessagesContext);
  const [statusOnlineUsers, setStatusOnlineUsers] = onlineValue;

  const { salesListState } = useContext(ChatContext);
  const [salesList, setSalesList] = salesListState;
  const [userList, setUserList] = useState([]);
  const [choosenDept, setChoosenDept] = useState("");
  const [filteredUsers, setFilteredUsers] = useState([]);

  const [dropdownOpen, setDropdownOpen] = useState(false);
  const toggleDropDown = () => setDropdownOpen(!dropdownOpen);

  let roleFunctions = getPermission()["departments"]?.access || [];

  const salesID = "SALES,CS";

  const refreshUserList = async () => {
    let responseGetSales = null;
    let responseGetCS = null;
    setSearch("");

    // segregation of duty implementation
    if (roleFunctions.includes("Access_All_Dept")) {
      responseGetSales = await serviceGetUsersByRoleId(cookies.SIDikey, "", salesID);
      // responseGetCS = await serviceGetUsersByRoleId(cookies.SIDikey, "", csID);
    } else {
      responseGetSales = await serviceGetUsersByRoleId(cookies.SIDikey, cookies.departmentIds, salesID);
      // responseGetCS = await serviceGetUsersByRoleId(cookies.SIDikey, cookies.departmentIds, csID);
    }

    if (!responseGetSales) {
      return;
    }

    if (
      (responseGetSales && new RegExp(/20+/).test(responseGetSales?.status)) ||
      (responseGetCS && new RegExp(/20+/).test(responseGetCS?.status))
    ) {
      const data = [...responseGetSales.data.data];
      setUserList(data.filter((item) => item.isActive === true).sort((a, b) => b.status.localeCompare(a.status)));
      setSalesList(data);
    }
  };

  const refreshUserListDept = async (deptId) => {
    let responseGetSales = null;
    let responseGetCS = null;
    // segregation of duty implementation
    responseGetSales = await serviceGetUsersByRoleId(cookies.SIDikey, [deptId], "SALES,CS");
    // responseGetCS = await serviceGetUsersByRoleId(cookies.SIDikey, [chat.channel.departmentId], 'CS');

    if (!responseGetSales) {
      return;
    }

    if (
      (responseGetSales && new RegExp(/20+/).test(responseGetSales?.status)) ||
      (responseGetCS && new RegExp(/20+/).test(responseGetCS?.status))
    ) {
      const data = [...responseGetSales.data.data];
      setUserList(data.filter((item) => item.isActive === true).sort((a, b) => b.status.localeCompare(a.status)));
      setSalesList(data);
    }
  };

  useEffect(() => {
    if (!isModalFilterUserOpen) {
      setSearch("");
    } else {
      refreshUserList();
    }
  }, [isModalFilterUserOpen]); // eslint-disable-line react-hooks/exhaustive-deps

  useEffect(() => {
    if (statusOnlineUsers.length === 0) {
      return;
    }

    const uL = userList;
    const uLFinal = [];
    uL.forEach((element) => {
      if (statusOnlineUsers.find((so) => so.id === element.id && so.status === "ONLINE")) {
        element.status = "ONLINE";
      } else if (statusOnlineUsers.find((so) => so.id === element.id && so.status === "OFFLINE")) {
        element.status = "OFFLINE";
      }
      uLFinal.push(element);
    });

    if (!!statusOnlineUsers) {
      setStatusOnlineUsers([]);
    }

    setUserList(
      uLFinal
        .sort((a, b) => b.status.localeCompare(a.status))
        .filter((item) => item.role.name === "SALES" || item.role.name === "CS"),
    );
  }, [statusOnlineUsers]); // eslint-disable-line react-hooks/exhaustive-deps

  const onRefreshClicked = async () => {
    await refreshUserList();
  };

  useEffect(() => {}, []);

  useEffect(() => {
    if (searchText !== "") {
      const newUsers = [];
      userList.forEach((data) => {
        const fullName = data.firstName + " " + data.lastName;
        if (fullName.toLowerCase().includes(searchText.toLowerCase())) {
          newUsers.push(data);
        }
      });
      setFilteredUsers(newUsers);
      setSalesList(newUsers);
    } else {
      refreshUserList();
      setFilteredUsers(userList);
    }
  }, [searchText]); // eslint-disable-line react-hooks/exhaustive-deps

  // //console.log(filteredUsers.length, searchText);
  return (
    <Modal
      isOpen={isModalFilterUserOpen}
      backdrop="static"
      keyboard={false}
      toggle={() => setIsModalFilterUserOpen(false)}
      className="modal-dialog-centered"
    >
      <ModalBody>
        <a
          href="#cancel"
          onClick={(ev) => {
            ev.preventDefault();
            setIsModalFilterUserOpen(false);
          }}
          className="close"
        >
          <Icon name="cross-sm"></Icon>
        </a>
        <Nav tabs>
          <Dropdown nav isOpen={dropdownOpen} toggle={toggleDropDown}>
            <DropdownToggle nav caret>
              {"All Department" && choosenDept}
              <Icon name="caret-down"></Icon>
            </DropdownToggle>
            <DropdownMenu>
              <DropdownItem
                style={{ color: activeTab === 0 ? "#4461F2" : "", cursor: "pointer" }}
                onClick={() => {
                  setActiveTab(0);
                  refreshUserList();
                  setChoosenDept("All Department");

                  // refreshUserListDept('ALL')
                  // setSelectedDepartment('');
                }}
              >
                All Department
              </DropdownItem>
              <DropdownItem divider />

              {userDetail.departments.map((dept, i) => {
                return (
                  <DropdownItem
                    key={dept.id}
                    style={{ color: activeTab === i + 1 ? "#4461F2" : "", cursor: "pointer" }}
                    onClick={() => {
                      setActiveTab(i + 1);
                      setChoosenDept(dept.name);
                      refreshUserListDept(dept.id);
                      // setSelectedDepartment(dept.id);
                    }}
                  >
                    {dept.name}
                  </DropdownItem>
                );
              })}
            </DropdownMenu>
          </Dropdown>

          <Button
            color="transparent"
            onClick={(e) => {
              e.preventDefault();
              onRefreshClicked();
              setChoosenDept("All Department");
            }}
          >
            Refresh
            <Icon className={"ml-1"} name="reload"></Icon>
          </Button>
        </Nav>
        <TabContent activeTab={activeTab}>
          <div className="form-control-wrap">
            <div className="form-icon form-icon-left">
              <Icon name="search"></Icon>
            </div>
            <input
              type="text"
              className="form-round form-control"
              id="default-03"
              placeholder="Search user"
              value={search}
              onChange={(e) => setSearch(e.target.value)}
            />
          </div>
          <SimpleBar style={{ maxHeight: "350px", minHeight: "350px" }}>
            {!searchText && isIncludeChatbot && (
              <div
                className="card-inner-md"
                key={-1}
                style={{ cursor: "pointer" }}
                onClick={() => (BOT_ID === selectedUserId ? setSelectedUserId("") : setSelectedUserId(BOT_ID))}
              >
                <div className="user-card">
                  <Icon
                    key={BOT_ID}
                    className={BOT_ID === selectedUserId ? "mr-1" : "invisible mr-1"}
                    name="check-circle-fill"
                    style={{ fontSize: 18, color: "#4461f2" }}
                  />
                  <UserAvatar icon={"reddit"} className={"border border-warning red"}></UserAvatar>
                  <div className="user-info">
                    <span className="lead-text">Chatbot</span>
                    <span className="sub-text">in bot session</span>
                  </div>
                  <div className="user-action">
                    <span
                      key={"BOT_DEPT"}
                      className="badge rounded-pill text-bg-primary"
                      style={{
                        background: "#ffffff",
                        color: getTextColor("#ffffff"),
                      }}
                    >
                      {""}
                    </span>
                  </div>
                </div>
              </div>
            )}
            {filteredUsers.length && searchText !== "" ? (
              filteredUsers.map((item, index) => {
                return (
                  <div
                    className="card-inner-md"
                    key={index}
                    style={{ cursor: "pointer" }}
                    onClick={() => (item.id === selectedUserId ? setSelectedUserId("") : setSelectedUserId(item.id))}
                  >
                    <div className="user-card">
                      <Icon
                        key={item.id}
                        className={item.id === selectedUserId ? "mr-1" : "invisible mr-1"}
                        name="check-circle-fill"
                        style={{ fontSize: 18, color: "#4461f2" }}
                      />
                      <UserAvatar theme={item.theme} text={findUpper(item.firstName)}>
                        {item.status === "ONLINE" ? (
                          <span className="status dot dot-lg dot-success"></span>
                        ) : (
                          <span className="status dot dot-lg dot-gray"></span>
                        )}
                      </UserAvatar>
                      <div className="user-info">
                        <span className="lead-text">{item.firstName + " " + item.lastName}</span>
                        <span className="sub-text">{item.email}</span>
                      </div>
                      <div className="user-action">
                        {item.departments.length > 0
                          ? item.departments.map((department) => (
                              <span
                                key={department.id}
                                className="badge rounded-pill text-bg-primary"
                                style={{
                                  background: department.color || "#ffffff",
                                  color: getTextColor(department.color || "#ffffff"),
                                }}
                              >
                                {department.name}
                              </span>
                            ))
                          : ""}
                      </div>
                    </div>
                  </div>
                );
              })
            ) : (salesList.length && searchText === "") || (!salesList.length && searchText === "") ? (
              salesList.map((item, index) => {
                return (
                  <div
                    className="card-inner-md"
                    key={index}
                    style={{ cursor: "pointer" }}
                    onClick={() => (item.id === selectedUserId ? setSelectedUserId("") : setSelectedUserId(item.id))}
                  >
                    <div className="user-card">
                      <Icon
                        key={item.id}
                        className={item.id === selectedUserId ? "mr-1" : "invisible mr-1"}
                        name="check-circle-fill"
                        style={{ fontSize: 18, color: "#4461f2" }}
                      />
                      <UserAvatar theme={item.theme} text={findUpper(item.firstName)}></UserAvatar>
                      <div className="user-info">
                        <span className="lead-text">{item.firstName + " " + item.lastName}</span>
                        <span className="sub-text">{item.email}</span>
                      </div>
                      <div className="user-action">
                        {item.departments.length > 0
                          ? item.departments.map((department) => (
                              <span
                                key={department.id}
                                className="badge rounded-pill text-bg-primary"
                                style={{
                                  background: department.color || "#ffffff",
                                  color: getTextColor(department.color || "#ffffff"),
                                }}
                              >
                                {department.name}
                              </span>
                            ))
                          : ""}
                      </div>
                    </div>
                  </div>
                );
              })
            ) : (
              <p className="mt-4">No user matched</p>
            )}
          </SimpleBar>

          <div className="row">
            <Button
              color="danger"
              className="col-3 mt-2 mr-3"
              style={{ width: "100%", justifyContent: "center" }}
              onClick={(e) => {
                e.preventDefault();
                setSelectedUserId("");
                filterChatByUserId("");
                setFilterUserName("");
              }}
            >
              Clear
            </Button>
            <Button
              color="primary"
              className="col-8 mt-2"
              style={{ width: "100%", justifyContent: "center" }}
              onClick={(e) => {
                e.preventDefault();
                filterChatByUserId(selectedUserId);
                let selectedUser = salesList.find((sl) => sl.id === selectedUserId);
                let userName =
                  selectedUserId === BOT_ID ? "Chatbot" : selectedUser.firstName + " " + selectedUser.lastName;
                setFilterUserName(userName);
              }}
            >
              Filter
            </Button>
          </div>
        </TabContent>
      </ModalBody>
    </Modal>
  );
};

export default ChatFilterUser;
